import type { IUserPermission } from '../types/components';
import { asyncRoutes } from './routes';

/**
 * Check if user has wildcard (*:*) permission (superadmin)
 */
const hasWildcardPermission = (permissions: IUserPermission[]): boolean => {
  return permissions.some(
    perm => perm.resource_name === '*' && perm.action === '*',
  );
};

/**
 * Generate routes based on user permissions.
 * Users with wildcard permission (*:*) get all routes.
 * For now, all authenticated users get all routes - fine-grained
 * access control is handled at the component level using hasPermission.
 */
const generateRoutes = (permissions: IUserPermission[]) => {
  // If user has any permissions, they get access to all routes
  // Individual page/component access is controlled via hasPermission checks
  if (permissions.length > 0 || hasWildcardPermission(permissions)) {
    return asyncRoutes;
  }
  return asyncRoutes;
};

export { generateRoutes };
